<template>
  <AttensiDropdown
    name="dropdown-1"
    empty-card
    default-card-spacing
    class="about-dropdown"
  >
    <template #input-content>
      <label class="input-content-title">
        <img :src="aboutIcon" class="about-icon" alt="" />
        {{ $t('mainMenu.ABOUT') }}
      </label>
    </template>

    <template #dropdown-content>
      <ul>
        <li class="dropdown-item">
          <a
            href="https://legal.attensi.com/min-spec.html"
            class="dropdown-item-link"
            target="_blank"
          >
            {{ $t('mainMenu.MINIMAL_TECHNICAL_SPECIFICATIONS') }}
          </a>
        </li>
        <li v-if="privacyPolicy" class="dropdown-item">
          <a :href="privacyPolicy" class="dropdown-item-link" target="_blank">
            {{ $t('mainMenu.PRIVACY_POLICY') }}
          </a>
        </li>
        <li class="dropdown-item">
          <a
            href="https://legal.attensi.com/eula.html"
            class="dropdown-item-link"
            target="_blank"
          >
            {{ $t('mainMenu.TERMS_OF_USE') }}
          </a>
        </li>
        <li class="dropdown-item">
          <a
            href="https://legal.attensi.com/licenses.html"
            class="dropdown-item-link"
            target="_blank"
          >
            {{ $t('mainMenu.OPEN_SOURCE_LIBRARIES') }}
          </a>
        </li>
        <li class="dropdown-item">
          <a
            href="https://legal.attensi.com/cookie-policy.html"
            class="dropdown-item-link"
            target="_blank"
          >
            {{ $t('mainMenu.COOKIE_POLICY') }}
          </a>
        </li>
      </ul>
    </template>
  </AttensiDropdown>
</template>

<script>
import { mapGetters } from 'vuex'
import { AttensiDropdown } from '@attensi/materia'
import { aboutIcon } from '@/assets/img'
import { useCurrentCompany } from '@/hooks/swr/useCurrentCompany'

export default {
  components: {
    AttensiDropdown,
  },
  data() {
    return {
      aboutIcon,
    }
  },
  computed: {
    ...mapGetters(['contentLocale']),

    privacyPolicy() {
      const privacyPolicies = useCurrentCompany().data.value?.privacy_policies

      if (privacyPolicies) {
        return privacyPolicies.find(
          (policy) => policy.locale === this.contentLocale
        )?.html_url
      }
      return ''
    },
  },
}
</script>

<style lang="scss" scoped>
.input-content-title {
  display: flex;
  cursor: pointer;
  padding: $spacing-5xs 0px;
  gap: $spacing-xs;
}

.about-icon {
  width: $spacing-xs;
  height: $spacing-xs;
  aspect-ratio: 1;
}

.dropdown-item {
  padding: $spacing-4xs $spacing-2xs;

  &:hover {
    background: $color-pebble;
    border-radius: $spacing-4xs;
  }
}

.dropdown-item-link {
  @include subtitle-2;
  width: 100%;
  color: $color-text;
  font-weight: 400;
}
</style>
